import { StringId } from "effect-app/Schema"

interface SnackbarState {
  id: StringId
  show: boolean
  text: string
  color: string
  timeout: number
  dark?: boolean | undefined
  light?: boolean | undefined
  action?: SnackbarAction | undefined
}

export interface SnackbarAction {
  label: string
  onClick: () => void
}

/**
 * @internal
 */
export const snackbarState = ref(snackbarFactory())

function snackbarFactory(): SnackbarState {
  return {
    id: StringId.make(),
    show: false,
    text: "",
    color: "success",
    timeout: 2000,
    dark: undefined,
    light: undefined,
    action: undefined
  }
}

export interface SnackbarOptions {
  text: string
  color?: "success" | "error" | "warning" | "info"
  timeout?: number
  dark?: boolean
  light?: boolean
  // a button next to the text, e.g. "Rückgängig"; clicking it also closes the snackbar
  action?: SnackbarAction
}

export function snackbar(options: SnackbarOptions) {
  const defaultState = snackbarFactory()
  snackbarState.value = { ...defaultState, ...options, show: true }
}
